// src/components/ui/Loading.js
import React from 'react';
import { Loader } from 'lucide-react';

/**
 * Exibe um indicador de carregamento centralizado.
 */
export const Loading = ({ text = "A carregar dados..." }) => (
    <div className="flex justify-center items-center p-20 min-h-[300px] bg-white/50 backdrop-blur-sm rounded-xl">
        <div className="flex flex-col items-center text-indigo-700">
            <Loader className="w-10 h-10 animate-spin mb-3" />
            <p className="text-lg font-semibold animate-pulse">{text}</p>
        </div>
    </div>
);

export default Loading;